import { useCallback } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import Button from '@mui/material/Button';

import { getLabelMessage } from '@gef-ui/localization/messages';
import GenericDialog from '@gef-ui/material/components/Dialog/GenericDialog';

const LightboxModal = NiceModal.create(
	({
		showConfirmButton = true,
		withCross = false,
		fullWidth = false,
		onExit,
		onConfirm,
		title,
		closeButtonLabel = getLabelMessage('confirm:cancel'),
		confirmButtonLabel = getLabelMessage('confirm:continue'),
		...other
	}) => {
		const modal = useModal();

		const handleExit = useCallback(() => {
			!!onExit && onExit(modal.id);
			modal.hide();
		}, [onExit, modal]);

		const handleConfirm = useCallback(() => {
			onConfirm();
			modal.hide();
		}, [onConfirm, modal]);

		return (
			<GenericDialog
				open={modal.visible}
				title={title}
				withCross={withCross}
				onExit={handleExit}
				fullWidth={fullWidth}
				backdropClose={false}
				actions={
					<>
						<Button onClick={handleExit}>{closeButtonLabel}</Button>
						{showConfirmButton && (
							<Button variant="contained" onClick={handleConfirm}>
								{confirmButtonLabel}
							</Button>
						)}
					</>
				}
				{...other}
			/>
		);
	},
);

export default LightboxModal;
